import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Progress } from 'antd';
import useInterval from '../../hooks/useInterval';

const START_DURATION = 400; // 400ms
const REFRESH_INTERVAL = 100; // 100ms

const MessageProgress = ({ duration }) => {
  // Convert duration from seconds to milliseconds
  duration = duration * 1000;

  const [counter, setCounter] = useState(START_DURATION);
  useInterval(() => {
    if (counter >= duration + START_DURATION) {
      return;
    }
    setCounter((counter) => counter + REFRESH_INTERVAL);
  }, REFRESH_INTERVAL);

  return (
    <div className="acast-message__progress">
      <Progress
        percent={(100 * counter) / duration}
        showInfo={false}
        style={{ width: '100%' }}
        size={4}
      />
    </div>
  );
};

export default MessageProgress;

MessageProgress.propTypes = {
  duration: PropTypes.number.isRequired,
};
